<template>
  <b-modal title="Detalhes do Laudo Técnico" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Modelo:" label-for="modelo" label-cols="3" label-align="right">
            <b-form-input id="modelo" v-model="template.modelo" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Segurança:" label-for="seguranca" label-cols="3" label-align="right">
            <b-form-input id="seguranca" v-model="template.seguranca" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Detalhe:" label-for="detalhe" label-cols="3" label-align="right">
            <b-form-input id="detalhe" v-model="template.detalhe" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Local:" label-for="local" label-cols="3" label-align="right">
            <b-form-input id="local" v-model="template.local" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Setor:" label-for="setor" label-cols="3" label-align="right">
            <b-form-input id="setor" v-model="template.setor" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="ART:" label-for="art" label-cols="3" label-align="right">
            <b-form-input id="art" v-model="template.art" />
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Tipo de Serviço:" label-for="tipo" label-cols="3" label-align="right">
            <b-form-input id="tipo" v-model="template.contrato.tipo" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Validade:" label-for="validade" label-cols="3" label-align="right">
            <b-form-input id="validade" v-model="template.contrato.validade" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Inicio:" label-for="inicio" label-cols="3" label-align="right">
            <b-form-datepicker
              id="inicio"
              v-model="template.contrato.inicio"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Término:" label-for="termino" label-cols="3" label-align="right">
            <b-form-datepicker
              id="termino"
              v-model="template.contrato.termino"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col cols="6">
          <b-form-group label="Responsabilidade:" label-for="empresa" label-cols="3" label-align="right">
            <b-form-select v-model="template.empresa">
              <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
                >{{ cliente.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Solicitante:" label-for="solicitante" label-cols="3" label-align="right">
            <b-form-select v-model="template.solicitante">
              <b-form-select-option v-for="cliente of clienteStore.clientes" v-bind:key="cliente.id" :value="cliente"
                >{{ cliente.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Engenheiro:" label-for="responsavel" label-cols="3" label-align="right">
            <b-form-select v-model="template.responsavel">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Registro CREA:" label-for="registro" label-cols="3" label-align="right">
            <b-form-input id="registro" v-model="template.registro" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label="Rodapé:" label-for="rodape" label-cols="1" label-align="right">
            <b-form-input id="rodape" v-model="template.rodape" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <template-laudo-modal ref="templateLaudo" @loadTemplate="loadTemplate($event)" />

    <template #modal-footer>
      <b-button variant="info" @click="templates()">Templates</b-button>
      <b-button variant="warning" @click="clear()">Limpar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useClienteStore } from "@/stores/ClienteStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import LaudoTecnico from "@/models_reports/LaudoTecnico";
import LaudoTecnicoTemplate from "@/components/reports/laudo_tecnico/modals/LaudoTecnicoTemplate";

export default {
  name: "ModalDeLaudoTecnicoDetalhe",

  components: {
    "template-laudo-modal": LaudoTecnicoTemplate,
  },

  data() {
    return {
      show: false,
      template: new LaudoTecnico(),
    };
  },

  methods: {
    templates() {
      this.$refs.templateLaudo.call();
    },

    clear() {
      this.template = new LaudoTecnico();
    },

    loadTemplate(template) {
      this.template.id = template.id;
      this.template.modelo = template.modelo;
      this.template.seguranca = template.seguranca;
      this.template.detalhe = template.detalhe;
      this.template.definicao = template.definicao;
      this.template.operacional = template.operacional;
      this.template.mecanica = template.mecanica;
      this.template.eletrica = template.eletrica;
      this.template.motor = template.motor;
      this.template.recomendar = template.recomendar;
      this.template.conclusao = template.conclusao;
      this.template.displayMecanica = template.displayMecanica;
      this.template.displayEletrica = template.displayEletrica;
      this.template.displayMotor = template.displayMotor;

      for (var i = 0; i < template.componentes.length; i++) {
        this.template.componentes.push({
          item: i + 1,
          descricao: template.componentes[i].descricao,
        });
      }

      for (var j = 0; j < template.normas.length; j++) {
        this.template.normas.push({
          item: template.normas[j].item,
          descricao: template.normas[j].descricao,
        });
      }

      for (var h = 0; h < template.condicoes.length; h++) {
        this.template.condicoes.push({
          item: h + 1,
          descricao: template.condicoes[h].descricao,
          condicao: template.condicoes[h].condicao,
        });
      }

      for (var r = 0; r < template.riscos.length; r++) {
        this.template.riscos.push({
          item: r + 1,
          descricao: template.riscos[r].descricao,
        });
      }

      for (var m = 0; m < template.mecanicos.length; m++) {
        this.template.mecanicos.push({
          item: m + 1,
          descricao: template.mecanicos[m].descricao,
          avaliacao: template.mecanicos[m].avaliacao,
        });
      }

      for (var e = 0; e < template.eletricos.length; e++) {
        this.template.eletricos.push({
          item: e + 1,
          descricao: template.eletricos[e].descricao,
          avaliacao: template.eletricos[e].avaliacao,
        });
      }

      for (var t = 0; t < template.motores.length; t++) {
        this.template.motores.push({
          item: t + 1,
          descricao: template.motores[t].descricao,
          avaliacao: template.motores[t].avaliacao,
        });
      }

      for (var d = 0; d < template.recomendacoes.length; d++) {
        this.template.recomendacoes.push({
          item: d + 1,
          recomendacao: template.recomendacoes[d].recomendacao,
        });
      }
    },

    call(laudo) {
      this.show = !this.show;
      this.template = laudo;
    },
  },

  setup() {
    const store = useSgcqStore();
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);
    const clienteStore = useClienteStore();
    const { getFilterClientes } = storeToRefs(clienteStore);

    return {
      store,
      profissionalStore,
      getProfissionais,
      clienteStore,
      getFilterClientes,
    };
  },
};
</script>

<style lang="scss" scoped></style>
